import { React, useEffect } from "react";
import { useAuth } from "../../firebase/authContext";
import { useNavigate } from "react-router-dom";
import LearningLevels from "./Home-Components/LearningLevels";
import FeaturesSection from "./Home-Components/FeaturesSection";
import HeroSection from "./Home-Components/HeroSection";
import AnimationSection from "./Home-Components/AnimationSection";

const HomePage = ({ setShowLoginPopup }) => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      navigate("/home");
    }
  }, [isLoggedIn, navigate]);

  return (
    <div className="flex flex-col min-h-screen">
      {/* Hero Section */}
      <HeroSection setShowLoginPopup={setShowLoginPopup} />

      {/* Features Section */}
      <FeaturesSection />

      {/* Learning Levels Section */}
      <LearningLevels />

      {/* Animation Section */}
      <AnimationSection />

      {/* Footer */}
      <footer className="bg-gray-800 text-gray-300 mt-auto">
        <div className="container mx-auto px-6 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Company Info */}
            <div className="text-center md:text-left">
              <h3 className="text-xl font-bold text-white mb-4">Dance.AI</h3>
              <p className="mb-4 leading-relaxed">
                Your personal dance studio powered by AI. Learn, practice, and
                perfect your dance moves with our innovative platform.
              </p>
            </div>

            {/* Quick Links */}
            <div className="text-center md:text-left">
              <h3 className="text-xl font-bold text-white mb-4">Quick Links</h3>
              <ul className="space-y-2">
                {[
                  { label: "Features", href: "#features" },
                  { label: "Classes", href: "#classes" },
                  { label: "Programs", href: "#programs" },
                  { label: "Pricing", href: "#pricing" },
                ].map((link, idx) => (
                  <li key={idx}>
                    <a
                      href={link.href}
                      className="hover:text-white transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div className="text-center md:text-left">
              <h3 className="text-xl font-bold text-white mb-4">Contact Us</h3>
              <div className="space-y-3">
                {/* Email */}
                <div className="flex items-center justify-center md:justify-start">
                  <svg
                    className="w-5 h-5 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  <a
                    href="mailto:stepwisedance@gmail.com"
                    className="hover:text-white transition-colors"
                  >
                    stepwisedance@gmail.com
                  </a>
                </div>

                {/* Phone */}
                <div className="flex items-center justify-center md:justify-start">
                  <svg
                    className="w-5 h-5 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                  <span>+1 (123) 456-7890</span>
                </div>

                {/* Location */}
                <div className="flex items-center justify-center md:justify-start">
                  <svg
                    className="w-5 h-5 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                  <span>San Francisco, CA</span>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-700 mt-8 pt-6 text-center text-sm">
            &copy; 2024 Dance.AI. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
